import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/use-intl.esm.js';
import { defaultOnError, defaultGetMessageFallback } from '../core/use-intl.esm6.js';
import validateMessages from '../core/use-intl.esm9.js';

var _excluded = ["getMessageFallback", "messages", "onError"];
/**
 * Enhances the incoming props with defaults.
 */

function getInitializedConfig(_ref) {
  var getMessageFallback = _ref.getMessageFallback,
      messages = _ref.messages,
      onError = _ref.onError,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var finalOnError = onError || defaultOnError;
  var finalGetMessageFallback = getMessageFallback || defaultGetMessageFallback;

  if (process.env.NODE_ENV !== 'production') {
    if (messages) {
      validateMessages(messages, finalOnError);
    }
  }

  return _extends({}, rest, {
    messages: messages,
    onError: finalOnError,
    getMessageFallback: finalGetMessageFallback
  });
}

export { getInitializedConfig as default };
//# sourceMappingURL=use-intl.esm9.js.map
